<template>
  <div class="is-main">
    <article class="section full-width flap-long-word">
      <div class="level-left full-width">
        <button
          class="button has-text-weight-bold is-text"
          type="button"
          v-on:click="go_To_Ivent"
        >{{ivent_name}}</button>
      </div>
    </article>
    <main class="section full-width">
      <section class="level is-mobile">
        <div class="level-left">
          <div class="level-item"></div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <button class="button is-success" v-on:click="open_Create" v-if="can_create_is==true">
              <b-icon pack="fas" icon="cart-plus"></b-icon>
            </button>
          </div>
        </div>
      </section>
      <ul>
        <li v-for="(product) in product_list" :key="product.data().name">
          <product
            v-on:order_Open_Edit="open_Edit"
            v-on:order_Open_Delete="open_Delete"
            v-bind:product="product"
          ></product>
        </li>
      </ul>
    </main>
    <div class="set-foot">
      <footer class="footer full-foot is-site-coler">
        <article class="level is-mobile">
          <div class="level-left">
            <div class="level-item">
              <b-icon pack="fas" icon="yen-sign"></b-icon>
              <p class="has-text-weight-bold">{{total_sum}}</p>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <button class="button is-success" type="button" v-on:click="payout">
                <p class="has-text-weight-bold">清算</p>
              </button>
            </div>
          </div>
        </article>
      </footer>
    </div>

    <!-- modal area -->
    <b-modal :active.sync="is_Create" has-modal-card>
      <section class="section">
        <create v-on:order_Close_Create="close_Create"></create>
      </section>
    </b-modal>
    <b-modal :active.sync="is_Edit" has-modal-card>
      <section class="section">
        <edit v-on:order_Close_Edit="close_Edit"></edit>
      </section>
    </b-modal>
    <b-modal :active.sync="is_Delete" has-modal-card>
      <section class="section">
        <deleteis v-on:order_Close_Delete="close_Delete" v-bind:user="user"></deleteis>
      </section>
    </b-modal>
    <!-- modal area -->
  </div>
</template>

<script>
import product from "@/components/product/Product.vue";
import create from "@/components/product/Create.vue";
import edit from "@/components/product/Edit.vue";
import deleteis from "@/components/product/Delete.vue";
import "@/store/Fire_Base_API.js";
import product_API from "@/store/Product_API.js";
import auth from "@/mixin/Auth.vue";
import toastre from "@/mixin/Toaster.vue";

export default {
  name: "Product_Home",
  components: {
    product,
    create,
    edit,
    deleteis
  },
  mixins: [auth, toastre],
  data: function() {
    return {
      ivent_id: this.$route.params.id,
      ivent_name: this.$route.params.name,
      //商品一覧
      product_list: [],
      // ユーザ情報を取得してからcreateの表示を可能にする
      can_create_is: false,
      // createの表示制御
      is_Create: false,
      // editの表示制御
      is_Edit: false,
      // deleteの表示制御
      is_Delete: false
    };
  },
  methods: {
    // 商品取得
    get_List: function() {
      this.product_list = {};

      product_API.get_Product_List(this.user, this.ivent_id).then(
        from_product_list => {
          this.product_list = [];
          Object.keys(from_product_list).forEach(index => {
            this.product_list.splice(index, 1, from_product_list[index]);
          });

          this.can_create_is = true;
        },
        () => {
          this.display_Error(
            "商品の取得に失敗しました。画面を更新してください。連続して失敗する場合はご連絡ください。"
          );
        }
      );
    },
    // 清算し商品数をリセットする
    payout: function() {
      this.$store.dispatch("product/init_Total_Price");

      this.get_List();

      this.display_Success("商品を清算しました。");
    },
    // 作成画面を開く
    open_Create: function() {
      this.is_Create = true;
    },
    // 作成画面を閉じる
    close_Create: function() {
      this.is_Create = false;

      this.get_List();
    },
    // 編集画面を開く
    open_Edit: function() {
      this.is_Edit = true;
    },
    // 編集画面を閉じる
    close_Edit: function() {
      this.is_Edit = false;

      this.get_List();
    },
    // 削除画面を開く
    open_Delete: function() {
      this.is_Delete = true;
    },
    // 削除画面を閉じる
    close_Delete: function() {
      this.is_Delete = false;

      this.get_List();
    },
    go_To_Ivent: function() {
      this.$router.push({
        name: "Ivent_Home"
      });
    }
  },
  mounted() {
    this.$store.dispatch("product/display_Product_List", this.ivent_id);
  },
  computed: {
    total_sum() {
      return this.$store.getters["product/total_price"];
    }
  }
};
</script>

<style>
.is-main {
  flex: 1;
}

.set-foot {
  position: sticky;
  bottom: 0;
}

.full-width {
  min-width: 100%;
}

.full-foot {
  min-height: 100%;
}
</style>
